import { Routes } from '@angular/router';

import { RootComponent } from '../root/root.component';
import { ListComponent } from './list/list.component';
import { DealerHomeComponent } from './home/dealer-home/dealer-home.component';

import { AuthGuard } from '../auth.guard';

import { BusinessManagementComponent } from './business-management/business.management.component';
import { ProjectManagementComponent } from './project-management/project.management.component';
import { QuoteTemplateComponent } from './quote/quote-template/quote-template.component';
import { AccountComponent } from '../account/account/account.component';


export const routing: Routes = [
  {
    path: 'admin', data: {
      breadcrumb_en: 'Admin',
      breadcrumb_es: 'Administración'
    },
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      { path: '', component: DealerHomeComponent },
      {
        path: 'idiAdmin', component: DealerHomeComponent,
        data: {
          breadcrumb_en: 'IDI Admin',
          breadcrumb_es: 'IDI Admin'
        },
      },
      {
        path: 'business', component: BusinessManagementComponent,
        data: {
          breadcrumb_en: 'Business Management',
          breadcrumb_es: 'Business Management'
        },
      },
      {
        path: 'project', component: ProjectManagementComponent, data: {
          breadcrumb_en: 'Project Management',
          breadcrumb_es: 'Gestión de Proyectos '
        },
      },
      {
        path: 'account', component: AccountComponent, data: {
          breadcrumb_en: 'My Account',
          breadcrumb_es: 'Mi Cuenta'
        },
      },
      {
        path: 'template/:templateId', component: QuoteTemplateComponent, data: {
          breadcrumb_en: 'Quotes',
          breadcrumb_es: 'Cotizaciónes'
        },
      },
      {
        path: 'list/:action', pathMatch: 'prefix',
        component: ListComponent, data: {
          breadcrumb_en: 'List',
          breadcrumb_es: 'Lista'
        },
      },

    ]
  }
];
